module.exports = __webpack_public_path__ + "img/KMSAT-15-check-mark.563045a9.png";